import {ListViewContext} from '../../contextProvider/ListViewProvider'
import {ISelectOption} from '../../core/_model'
import SelectList from '../SelectList'
import SelectEntriesOptions from './SelectEntriesOptions'

type Props = {
  size: number
  handlePagePerItem: (itemsPerPage: number) => void
  modalToggle?: boolean
  modalTargetId?: string
}

export const perPageItemsOptions: ISelectOption[] = [
  {id: 2, value: '10', label: '10'},
  {id: 3, value: '20', label: '20'},
  {id: 4, value: '50', label: '50'},
  {id: 4, value: '100', label: '100'},
  {id: 4, value: '150', label: '150'},
  {id: 4, value: '200', label: '200'},
]

const TableContentHeader = ({size, handlePagePerItem, modalTargetId, modalToggle}: Props) => {
  return (
    <div className='my-4 d-flex justify-content-between align-items-center'>
      <div className='d-flex justify-content-between align-items-center gap-4'>
        <span className='text-muted fs-5 fw-medium'>Entries</span>
        <SelectEntriesOptions
          options={perPageItemsOptions}
          handleSelect={handlePagePerItem}
          value={size.toString()}
        />
      </div>
      <SelectList
        context={ListViewContext}
        modalTargetId={modalTargetId}
        modalToggle={modalToggle}
      />
    </div>
  )
}

export default TableContentHeader
